var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8213 0.179998C20.7361 0.0947733 20.6278 0.0364497 20.5098 0.0122714C20.3917 -0.0119068 20.2692 -0.000874408 20.1573 0.0439984L0.387329 7.952C0.276481 7.99617 0.180878 8.07164 0.112173 8.1692C0.0434681 8.26676 0.00462848 8.3822 0.000388486 8.50145C-0.00385151 8.6207 0.0266913 8.73861 0.0882939 8.8408C0.149897 8.943 0.239898 9.02506 0.347329 9.077L8.14733 12.858L11.9283 20.658C11.9786 20.7619 12.0572 20.8496 12.155 20.9109C12.2528 20.9723 12.3659 21.0049 12.4813 21.005H12.5003C12.6194 21.0007 12.7347 20.962 12.8321 20.8935C12.9296 20.825 13.005 20.7296 13.0493 20.619L20.9573 0.843998C21.0022 0.732168 21.0132 0.609619 20.9891 0.491572C20.9649 0.373526 20.9066 0.265182 20.8213 0.179998ZM2.13733 8.577L17.8313 2.299L8.47833 11.652L2.13733 8.577ZM12.4243 18.863L9.34833 12.522L18.7003 3.17L12.4243 18.863Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend1);
export default __webpack_public_path__ + "static/media/send 1.065775a971cf6cc06c2c097136b1c470.svg";
export { ForwardRef as ReactComponent };